// extracted by mini-css-extract-plugin
export default {"noBorderCard":"_2KrDlqv3nku7I0E32frPm2","cardHeaderMore":"JxAKxteJZocL90GDoudGy"};